const eventSubscription = ({ getState }) => {
  return (next) => (action) => {
    // console.log("Próximo", action);

    // trigger listeners for the given
    // action type
    const { type, payload } = action;
    window.ReduxSubscriber.trigger(type, payload);

    return next(action);
  };
};

export default eventSubscription;
